import { render, staticRenderFns } from "./Endorse.vue?vue&type=template&id=693972ba&"
import script from "./Endorse.vue?vue&type=script&lang=js&"
export * from "./Endorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports